import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "certification-updates-header-wrapper" }
const _hoisted_2 = {
  key: 1,
  class: "certification-updates-content"
}
const _hoisted_3 = { class: "description" }

import OpalPill from "@/components/shared/OpalPill.vue";
import Loader from "@/components/shared/Loader.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CertificationUpdate',
  props: {
    certificationCount: {},
    status: {},
    showLoader: { type: Boolean, default: true },
    error: { type: Boolean, default: false },
    loaded: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "header" }, "Certification Updates", -1)),
      _withDirectives(_createVNode(OpalPill, {
        content: __props.status,
        class: "inline-pill pill-gray"
      }, null, 8, ["content"]), [
        [_vShow, __props.certificationCount > 0 && __props.status]
      ])
    ]),
    (__props.showLoader)
      ? (_openBlock(), _createBlock(Loader, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "description")
          ]),
          _renderSlot(_ctx.$slots, "default")
        ]))
  ], 64))
}
}

})